import React, { useEffect, createElement } from 'react';
interface LinkedInTagProps {
  partnerId: string;
}
export const LinkedInTag = ({
  partnerId
}: LinkedInTagProps) => {
  useEffect(() => {
    // Create the LinkedIn Insight Tag script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
      _linkedin_partner_id = "${partnerId}";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      (function(l) {
        if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
        window.lintrk.q=[]}
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";
        b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);
      })(window.lintrk);
    `;
    // Add the script to the document
    document.body.appendChild(script);
    // Add the noscript pixel for non-JS environments
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.alt = '';
    img.src = `https://px.ads.linkedin.com/collect/?pid=${partnerId}&fmt=gif`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    // Cleanup function
    return () => {
      document.body.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, [partnerId]);
  return null; // This component doesn't render anything
};